import styled from 'styled-components'
import { NavLink, useLocation } from 'react-router-dom'
import { _ } from '~/assets/localization/util'
import { trackEventInternal } from '~/analytics/eventTracking'
import { colors, fontSize } from '~/assets/styleConstants'
import { RoutePath } from '~/routing'
import { UserMenu } from '../Common/UserMenu'
import { CaptureLogoHorizontal } from '../Icons/CaptureLogoHorizontal'
import { ThreeAreasNavBar } from './ThreeAreasNavBar'

const NavElement = styled(NavLink)`
    font-size: ${fontSize.medium_18};
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 2px;
    color: ${colors.captureGrey800};
    padding-bottom: 14px;
    border-bottom: 4px solid transparent;
    margin: 0 30px -16px;
    display: inline-block;
    cursor: pointer;

    &.active {
        font-weight: bold;
        color: ${colors.captureBlue};
        border-bottom: 4px solid ${colors.captureBlue};
    }
`

type MainTopNavBarProps = {
    hideUserAvi?: boolean
}

export function MainNavBarDesktop({ hideUserAvi }: MainTopNavBarProps) {
    const location = useLocation()
    const makeNavButton = (label: string, pageUrl: string, cy?: string) => ({
        label,
        pageUrl,
        onClick: () => {
            trackEventInternal(
                `${location.pathname
                    .substring(1)
                    .replaceAll('/', '_')}_navbar_${
                    pageUrl === RoutePath.Timeline
                        ? 'photos_clicked'
                        : 'albums_clicked'
                }`,
            )
        },
        cy,
    })
    const navButtons = [
        makeNavButton(_('me'), RoutePath.Me, 'me__nav'),
        makeNavButton(_('timeline'), RoutePath.Timeline, 'photos__nav'),
        makeNavButton(_('albums'), RoutePath.Albums, 'albums__nav'),
    ]

    const navElements = navButtons.map((link) => {
        return (
            <NavElement
                key={link.label}
                data-cy={link.cy}
                onClick={link.onClick}
                onKeyUp={link.onClick}
                to={link.pageUrl}
                className={({ isActive, isPending, isTransitioning }) =>
                    [
                        isPending ? 'pending' : '',
                        isActive ? 'active' : '',
                        isTransitioning ? 'transitioning' : '',
                    ].join(' ')
                }>
                {link.label}
            </NavElement>
        )
    })

    const leftElements = [<CaptureLogoHorizontal key={'logo'} />]

    const rightElements = [
        !hideUserAvi && (
            <UserMenu key="avi_area" showSeparator={false} size={32} />
        ),
    ].filter(Boolean)

    return (
        <ThreeAreasNavBar
            left={leftElements}
            middle={navElements}
            right={rightElements}
        />
    )
}
